module.exports = __webpack_public_path__ + "static/media/catalogueImg1.fec6acb5.png";